import React, { FunctionComponent } from 'react';
import { StyleSheet, Text, View, ViewStyle } from 'react-native';
import ExclamationIcon from '../../assets/images/exclamation.svg';
import Theme from '../../theme';
import { defaultScale } from '../../utils/scaling';

interface IProps {
  messageHeading?: string;
  message?: string;
  containerStyle?: ViewStyle;
}

export const InfoAlert: FunctionComponent<IProps> = (
  {
    message,
    messageHeading,
    containerStyle,
  },
) => {
  if (!message) {
    return <></>;
  }

  return (
    <View style={[styles.container, containerStyle]}>
      <View style={styles.iconContainer}>
        <ExclamationIcon color={Theme.GREY_FIGMA_MEDIUM_LIGHT} />
      </View>
      <View style={{ flex: 1 }}>
        {messageHeading &&
          <Text style={styles.heading}>
            {messageHeading}
          </Text>
        }
        <Text style={styles.text}>
          {message}
        </Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    borderWidth: 1,
    borderColor: Theme.GREY_FIGMA_LIGHT,
    padding: defaultScale(15),
    flexDirection: 'row',
  },
  iconContainer: {
    paddingTop: defaultScale(5),
    marginRight: defaultScale(8),
  },
  textContainer: {
    flex: 1,
  },
  heading: {
    ...Theme.textStyle.bodyCopyBold,
    color: Theme.GREY_FIGMA_MEDIUM_LIGHT,
    marginBottom: defaultScale(5),
  },
  text: {
    ...Theme.textStyle.bodyCopyReg,
    color: Theme.GREY_FIGMA_MEDIUM_LIGHT,
  },
});
